/**
 * 全屏绘图视图组件
 * 用于在接近全屏的状态下展示 aidrawio 绘图工具
 */

import React, { useState, useEffect, useMemo } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { AIDRAWIO_URL } from '../config/serviceConfig';

/**
 * FullscreenDrawingView - 全屏绘图视图
 * 复用 FullscreenAgentView 的样式，展示 aidrawio 绘图界面
 * 
 * @param {Function} onClose - 关闭回调函数
 * @param {Object} currentUser - 当前用户信息
 * @param {string} sessionId - 会话ID
 */
const FullscreenDrawingView = React.memo(({ onClose, currentUser, sessionId }) => {
  const [isLoading, setIsLoading] = useState(true);

  // 禁止背景滚动
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  // 🎨 构建带用户信息的 aidrawio URL
  const drawioUrlWithParams = useMemo(() => {
    let userId = 'guest';
    let userType = 'guest';
    
    if (currentUser) {
      if (currentUser.isSchoolUser) {
        userId = currentUser.unified_user_id || currentUser.username;
        userType = 'campus';
      } else if (currentUser.isCasUser) {
        userId = currentUser.unified_user_id || currentUser.employeeNumber;
        // ✅ 修正：从用户数据中读取 user_type，而不是硬编码
        userType = currentUser.user_type || 'bupt_cas'; // 如果没有设置，默认为 bupt_cas（向后兼容）
      } else {
        userId = currentUser.unified_user_id || `guest_${currentUser.username}`;
        userType = 'guest';
      }
    }
    
    const params = new URLSearchParams({
      sessionId: sessionId || '',
      unifiedUserId: userId,
      userType: userType
    });
    
    return `${AIDRAWIO_URL}?${params.toString()}`;
  }, [currentUser, sessionId]);

  return (
    <div className="partial-fullscreen-overlay">
      <div className="fullscreen-agent-container">
        {/* 头部：返回按钮 + 标题 */}
        <div className="fullscreen-agent-header">
          <button className="fullscreen-back-btn" onClick={onClose}>
            <ArrowBackIosNewIcon fontSize="small" />
            返回
          </button>
          <h2>🎨 AI 绘图助手</h2>
          <div className="fullscreen-header-spacer"></div>
        </div>

        {/* 内容区：iframe 加载 aidrawio */}
        <div className="fullscreen-agent-content">
          {isLoading && (
            <div className="iframe-loading">正在加载绘图工具...</div>
          )}
          <iframe
            src={drawioUrlWithParams}
            style={{ width: '100%', height: '100%', border: 'none' }}
            frameBorder="0"
            title="AI 绘图助手"
            onLoad={() => setIsLoading(false)}
          />
        </div>
      </div>
    </div>
  );
});

export default FullscreenDrawingView;
